import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {FormsService} from '../../../../intelligence-data-entry/services/forms.service';
import {MessageService} from '../../../../shared/services/message.service';

@Component({
  selector: 'app-upload-forms',
  templateUrl: './upload-forms.component.html',
  styleUrls: ['./upload-forms.component.scss']
})
export class UploadFormsComponent implements OnInit {

  file!: File;
  fileExtension!: string;
  accept = '.xls,.xlsx';

  fileForm = this.formBuilder.group({
    file: []
  });

  get fileControl(): FormControl {
    return this.fileForm.get('file') as FormControl;
  }
  constructor(private formBuilder: FormBuilder,
              private readonly router: Router,
              private readonly formsService: FormsService,
              private messageService: MessageService) { }

  ngOnInit(): void {
  }

  uploadFile(): void {
    this.file = this.fileControl.value;
    this.formsService.uploadAnswers(this.file).subscribe(
      () => {
        const url = this.router.url;
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(
          () => this.router.navigate([url]).then(
            () => this.messageService.showMessage('Saved successfully', 'success')
          )
        );
      }
    );
  }

  getExtension(): void {
    this.file = this.fileControl.value;
    const fileName = this.file.name.split('.');
    this.fileExtension = fileName[fileName.length - 1];
  }

}
